import { render } from "./NotifyAboutPassingsForm.vue?vue&type=template&id=8bb3903a&scoped=true"
import script from "./NotifyAboutPassingsForm.vue?vue&type=script&lang=js"
export * from "./NotifyAboutPassingsForm.vue?vue&type=script&lang=js"

import "./NotifyAboutPassingsForm.vue?vue&type=style&index=0&id=8bb3903a&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bb3903a"]])

export default __exports__